import React from "react";
import { Provider } from "mobx-react";

import MessagingStorage from "../../storages/MessagingStorage";
import Messaging from "./Messaging";

const Container = ({ maxAttachmentBytes, noRecordsMessage }) => {
  const messagingStorage = new MessagingStorage(
    Application.currentUser.locations,
    maxAttachmentBytes
  );
  const storage = { messagingStorage };

  return (
    <Provider {...storage}>
      <Messaging noRecordsMessage={noRecordsMessage} />
    </Provider>
  );
};

export default Container;
